.loader {
    position: relative;
    width: 100%;
    height: 4px;
    background-color: #e0e0e0;
  }
  
  .indeterminate {
    background-color: var(--primary-color);
    position: absolute;
    width: 50%;
    height: 100%;
    animation: indeterminate 2s linear infinite;
  }
  
  @keyframes indeterminate {
    0% {
      left: -50%;
    }
    50% {
      left: 100%;
      width: 100%;
    }
    100% {
      left: 100%;
      width: 50%;
    }
  }
  